import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import getLang from 'I18n/utils/getLang';
import Raven from 'raven-js';
import UIButton from 'UIComponents/button/UIButton';
import { useAddToPlaylist } from '../../savedItems';

const AddItemToPlaylistButton = (_ref) => {
  let {
    children,
    itemId,
    playlistId,
    itemType,
    language = getLang(),
    onSuccess,
    showNotification = true,
    onClick,
    use = 'unstyled'
  } = _ref,
      buttonProps = _objectWithoutPropertiesLoose(_ref, ["children", "itemId", "playlistId", "itemType", "language", "onSuccess", "showNotification", "onClick", "use"]);

  const [addToPlaylist, {
    addToPlaylistMutationLoading
  }] = useAddToPlaylist({
    showNotification
  });

  const handleOnClick = e => {
    if (addToPlaylistMutationLoading) return;
    if (onClick) onClick(e);
    addToPlaylist({
      playlistId,
      itemId,
      language,
      type: itemType
    }).then(onSuccess).catch(() => {
      Raven.captureMessage(`Achievements: error adding item to playlist`, {
        extra: {
          playlistId,
          itemId,
          language,
          itemType
        }
      });
    });
  };

  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
    onClick: handleOnClick,
    use: use,
    children: children
  }));
};

export default AddItemToPlaylistButton;